import React, { useState, useEffect } from 'react';

const ViewImageAndText = ({ inputString, onViewImage }) => {
    const [stringParse, setStringParse] = useState(null);

    useEffect(() => {
        const extractLinksAndText = (inputString) => {
            const urlRegex = /<img[^>]+>/g;
            let matches;
            const imgTags = [];
            let text = inputString;

            // Extract all img tags
            while ((matches = urlRegex.exec(inputString)) !== null) {
                imgTags.push(matches[0]);
            }

            // Remove all img tags from the text
            imgTags.forEach(imgTag => {
                text = text.replace(imgTag, '').trim();
            });

            return { imgTags, text };
        };

        const { imgTags, text } = extractLinksAndText(inputString);
        setStringParse({ imgTags, text });
    }, [inputString]);

    if (!stringParse) {
        return null; // or render a loading state
    }

    return (
        <td>
            {stringParse.text && <p>{stringParse.text}</p>}
            {/* <div dangerouslySetInnerHTML={{ __html: stringParse.text }} /> */}

            {stringParse.imgTags.length > 0 && (
                <div>
                    <button
                        className="btn btn-primary"
                        onClick={() => onViewImage(stringParse.imgTags.join('<br/>'))}
                    >
                        View Image
                    </button>
                </div>
            )}
        </td>
    );
};

export default ViewImageAndText;
